import {getAPIGatewayRequest, getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {APIEndpoint} from "../../common/constants";

export async function getStationLiabilitySummary(params) {
    const {stationCode, startTime, endTime} = params;
    const requestParams = {
        stationCode,
        dateRange: {
            startTime: startTime,
            endTime: endTime
        }
    }

    try {
        let apiGatewayRequest = getAPIGatewayRequest(APIEndpoint.STATION_SUMMARY, requestParams, "POST");
        return getAPIGatewayDataFromParent(apiGatewayRequest);
    } catch (error) {
        throw error;
    }
}



// WEBPACK FOOTER //
// ./src/component/codSummary/network/StationEODSummaryAPI.js